import type { SimulatorProfileDefinition } from "../contracts/appManifest.js";

export const serverCoreProfile: SimulatorProfileDefinition = {
  id: "server-core",
  title: "FirstDesk Server Core Lab",
  productLabel: "FirstDesk Server Core Lab",
  machineRole: "server-core",
  theme: "core",
  desktopAppIds: ["cmd"],
  pinnedAppIds: ["cmd"],
  defaultOpenAppIds: ["cmd"],
  startMenuSections: [
    {
      title: "Core tools",
      appIds: ["cmd", "services", "server-manager"]
    }
  ]
};
